
import { motion } from "framer-motion";
import { Trophy } from "lucide-react";

const AboutSection = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <motion.div 
      {...fadeInUp}
      className="bg-white/5 rounded-xl p-8 backdrop-blur-sm border border-white/10 mb-12 hover:bg-white/10 transition-colors duration-300"
    >
      <h2 className="text-3xl md:text-4xl font-bold text-racing-accent mb-6 flex items-center gap-3">
        What is FF:RM?
        <Trophy className="w-8 h-8" />
      </h2>
      <ul className="space-y-4 text-gray-300">
        {[
          "<b>Front Runner: Racehorse Manager</b> is a free-to-play mobile and desktop strategy game that gives you the thrill of horse racing at your fingertips - from the stable, to the saddle, to the stands. Front Runner: Racehorse Manager isn't just another game; it's a chance to step into the world of horse racing like never before and grow your revenue portfolio.",
          "Published by The Winner's Circle, it blends strategy, competition, and ownership into a seamless gaming experience and user interface."
        ].map((item, index) => (
          <motion.li 
            key={index}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="flex items-start gap-3 text-lg leading-relaxed"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-racing-accent flex-shrink-0 mt-3" />
            <span dangerouslySetInnerHTML={{ __html: item }} />
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
};

export default AboutSection;
